import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const PRODUCT_URL = 'https://rylte.com/products/ems-microcurrent-facial-lifting-device';
interface CTAButtonProps {
  children: React.ReactNode;
}
export function CTAButton({
  children
}: CTAButtonProps) {
  return <motion.a href={PRODUCT_URL} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className="group flex w-full items-center justify-center gap-2 rounded-md bg-rust px-6 py-4 text-center text-base font-semibold uppercase tracking-wide text-paper shadow-sm transition-colors hover:bg-rust-dark sm:text-lg" data-id="element-333" data-mp="2fzbt2fmfje3u">
      <span data-id="element-334" data-mp="2yq2w6zftq89s">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-335" data-mp="2ypt7rgafg967" />
    </motion.a>;
}